"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FileSharingProtocolType;
(function (FileSharingProtocolType) {
    FileSharingProtocolType[FileSharingProtocolType["AmsBasedFileSharing"] = 0] = "AmsBasedFileSharing";
})(FileSharingProtocolType || (FileSharingProtocolType = {}));
exports.default = FileSharingProtocolType;
//# sourceMappingURL=FileSharingProtocolType.js.map